module.exports = __webpack_public_path__ + "img/mv-kanta.c4a57d29.webp";